import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-cancel",
  "use": "app-icon-cancel-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"app-icon-cancel\"><path d=\"M6.795 6l3.975-3.975a.566.566 0 000-.795.566.566 0 00-.795 0L6 5.205 2.025 1.23a.566.566 0 00-.795 0 .566.566 0 000 .795L5.205 6 1.23 9.975a.566.566 0 000 .795.566.566 0 00.795 0L6 6.795l3.975 3.975a.566.566 0 00.795 0 .566.566 0 000-.795L6.795 6z\" fill=\"#707070\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol